module.exports = __webpack_public_path__ + "img/vertical_stacked_bar_chart.02104833.svg";